import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EditableModule } from '@flyfreely-portal-ui/editable';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { FlyFreelyFormlyModule } from '@flyfreely-portal-ui/flyfreely-formly';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { Angulartics2Module } from 'angulartics2';
import { AddressesModule } from 'libs/addresses/src/lib/addresses.module';
import { InlineModalModule } from 'libs/inline-modal/src/lib/inline-modal.module';
import { LoadingIndicatorModule } from 'libs/loading-indicator/src/lib/loading-indicator.module';
import { SubscriptionsModule } from 'libs/subscriptions/src/lib/subscriptions.module';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxLoadingModule } from 'ngx-loading-reloaded';
import { NgxStripeModule } from 'ngx-stripe';
import { ToastrModule } from 'ngx-toastr';
import { BillingAddressAndTaxDetailsComponent } from './billing-address.component';
import { ConfirmPaymentDialogue } from './confirm-payment/confirm-payment.component';
import { CurrentSubscriptionComponent } from './current-subscription/current-subscription.component';
import { OrganisationSubscriptions } from './organisation-subscriptions.component';
import { PlanSelectionComponent } from './plan-selection/plan-selection.component';
import { PurchaseSubscriptionComponent } from './purchase-subscription/purchase-subscription.component';
import { UpdateSubscriptionComponent } from './update-subscription/update-subscription.component';
import { UpgradeSubscriptionDialogueComponent } from './upgrade-subscription/upgrade-subscription-dialogue.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TooltipModule,
        ReactiveFormsModule,
        NgSelectModule,
        ButtonsModule,
        NgxLoadingModule,
        ToastrModule,
        FormlyModule,
        FormlyBootstrapModule,
        Angulartics2Module,
        FlyFreelyFormlyModule,
        EnhancedHelpModule,
        AnalyticsModule,
        LoadingIndicatorModule,
        ValidationModule,
        InlineModalModule,
        SharedUiModule,
        LoadingIndicatorModule,
        EditableModule,
        AddressesModule,
        SubscriptionsModule,
        NgxStripeModule.forChild()
    ],
    declarations: [
        OrganisationSubscriptions,
        PlanSelectionComponent,
        PurchaseSubscriptionComponent,
        UpdateSubscriptionComponent,
        CurrentSubscriptionComponent,
        BillingAddressAndTaxDetailsComponent,
        ConfirmPaymentDialogue,
        UpgradeSubscriptionDialogueComponent
    ],
    exports: [OrganisationSubscriptions]
})
export class OrganisationSubscriptionsModule {}
